var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container solicitarInformacoes" }, [
    _c(
      "div",
      { staticClass: "content-cadastro solicitarInformacao" },
      [
        _c(
          "app-listagem",
          {
            attrs: {
              tituloCard: _vm.tituloCard,
              hasActionButton: true,
              sizeActionButton: _vm.sizeActionButton,
              nameActionButton: _vm.nameActionButton,
              hasHeader: true,
              hasRefreshButton: false,
              headerLabel: _vm.headerLabel,
              dataForTable: _vm.cadastros,
              totalElements: _vm.totalCadastros,
              pagina: _vm.pagina
            },
            on: { click: _vm.novoCadastro, changePage: _vm.changePage }
          },
          [
            _c(
              "template",
              { slot: "columns" },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "Nome/Razão social do interessado",
                    prop: "nomeRazaoSocial",
                    sortable: "sortable"
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "CPF/CNPJ do interessado",
                    formatter: _vm.interessadoFormatCpfCnpj
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Nome/Razão social do cadastrante",
                    formatter: _vm.cadastranteFormatNome
                  }
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Data de atualização",
                    width: "160",
                    formatter: _vm.setData
                  }
                }),
                _c("el-table-column", {
                  attrs: { label: "Ações", width: "110", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "click", size: "small" } },
                            [
                              _c(
                                "el-button",
                                { attrs: { type: "primary", size: "mini" } },
                                [
                                  _vm._v("Ações"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right"
                                  })
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("el-dropdown-item", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex",
                                            on: {
                                              click: function($event) {
                                                return _vm.$router.push({
                                                  name:
                                                    "informacoes/cadastrante",
                                                  params: {
                                                    idCadastro: scope.row.id
                                                  }
                                                })
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fal fa-pencil-alt"
                                            }),
                                            _vm._v("  Editar Cadastro")
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _c("el-dropdown-item", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex",
                                            on: {
                                              click: function($event) {
                                                return _vm.remove(scope.row)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-times"
                                            }),
                                            _vm._v("  Remover Cadastro")
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c74f744", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c74f744","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/solicitarInformacao/Home.vue
// module id = null
// module chunks = 